import React from 'react'
import PropTypes from 'prop-types'

const UserIcon = ({width, height}) => (
<svg className="icon" width={`${width}px`} height={`${height}px`} viewBox="0 0 24 24" version="1.1" xmlns="http://www.w3.org/2000/svg">
    {/* <title>9A43BB06-93BD-44F1-A1DC-D10C72FBE371</title> */}
    {/* <desc>Created with sketchtool.</desc> */}
    <g id="Dashboard" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g id="Dashboard-/-My-Account-/-Profile" transform="translate(-535.000000, -168.000000)" fill="#999999" fillRule="nonzero">
            <path d="M547,168 C540.4,168 535,173.4 535,180 C535,186.6 540.4,192 547,192 C553.6,192 559,186.6 559,180 C559,173.4 553.6,168 547,168 Z M547,171.6 C549.04,171.6 550.6,173.16 550.6,175.2 C550.6,177.24 549.04,178.8 547,178.8 C544.96,178.8 543.4,177.24 543.4,175.2 C543.4,173.16 544.96,171.6 547,171.6 Z M547,188.64 C544,188.64 541.36,187.080047 539.8,184.8 C539.8,182.4 544.6,181.08 547,181.08 C549.4,181.08 554.2,182.4 554.2,184.8 C552.64,187.08 550,188.64 547,188.64 Z" id="Shape"></path>
        </g>
    </g>
</svg>
)
UserIcon.defaultProps = {
    width: 24,
    height: 24
}

UserIcon.prototype = {
    width: PropTypes.string,
    height: PropTypes.string
}

export default UserIcon;